import React from 'react';

import { TextInput as RexlabsTextInput } from '@rexlabs/text-input';

const TextInput = (props) => <RexlabsTextInput {...props} />;

export default TextInput;
